import React, {MouseEvent} from 'react';
import {
    Box,
    FormControl,
    FormHelperText,
    IconButton,
    Input,
    InputAdornment,
    InputLabel,
    SvgIcon,
} from '@material-ui/core';
import PropTypes, {InferProps} from 'prop-types';
import {Visibility, VisibilityOff} from '@material-ui/icons';
import {ReactComponent as CheckIcon} from 'assets/icons/section/feedback/check.svg';

function EfePasswordField(props: InferProps<typeof EfePasswordField.propTypes>) {
    const {value, handleChange, error, label, name, disableHelper, handleBlur} = props;
    const [show, setShow] = React.useState<boolean>(false);

    /**
     * Hide/Show password value on click event
     */
    const handleClickShowPassword = () => {
        setShow(!show);
    };

    /**
     * Handle mouse event on password input
     * @param event
     */
    const handleMouseDownPassword = (event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    /**
     * Wrap Input Adornment for Password field
     */
    const PasswordInputAdornment = (
        <InputAdornment position='end'>
            <IconButton
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge='end'>
                {show ? <Visibility /> : <VisibilityOff />}
            </IconButton>
        </InputAdornment>
    );

    /* todo: change color on error state */
    const HelperText = (
        <Box display='flex' component='div' justifyContent='space-between'>
            {/* Check / Warning Icon. */}
            {!disableHelper && (
                <>
                    <Box m={1}>
                        {!error && (
                            <SvgIcon height={16} width={16} fontSize='small'>
                                <CheckIcon />
                            </SvgIcon>
                        )}
                    </Box>
                    {/* Helper Text. */}
                    <Box textAlign='left' flexGrow={1} m={1}>
                        {'Longitud m\u00EDnima: 8 caracteres.'}
                    </Box>
                </>
            )}
        </Box>
    );
    return (
        <FormControl fullWidth>
            <InputLabel shrink htmlFor='password' color={'secondary'}>
                {label ? label : 'Contrase\u00f1a'}
            </InputLabel>
            <Input
                color='secondary'
                id={name ? name : 'password'}
                name={name ? name : 'password'}
                value={value}
                onChange={handleChange}
                onBlur={handleBlur}
                error={error}
                endAdornment={PasswordInputAdornment}
                type={show ? 'text' : 'password'}
            />
            <FormHelperText component='div' error={error}>
                {HelperText}
            </FormHelperText>
        </FormControl>
    );
}

EfePasswordField.propTypes = {
    handleBlur: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    error: PropTypes.bool.isRequired,
    value: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    disableHelper: PropTypes.bool,
};

EfePasswordField.defaultProps = {
    error: false,
    value: '',
};

export default EfePasswordField;
